export const config = {
    defaultLanguage: 'en-US',
    defaultLanguageFullName: 'English',
    tokenPath: 'oauth/token',
    defaultAuthRealm: process.env.REACT_APP_DEFAULT_AUTH_REALM,
    apiAddress: process.env.REACT_APP_API_URL,
    JWTTokenRefreshIntervalMs: 900000, // 15 minutes
    JWTTokenRefreshInitialDelayMs: 60000, // 1 minute
    maxAvatarSizeInBytes: 1000000,
    iOSAppStoreURL: 'https://apps.apple.com/us/app/modern-health/id1445843859',
    AndroidGooglePlayStoreURL:
        'https://play.google.com/store/apps/details?id=com.modernhealth.modernhealth',
    messages: {
        genericError: 'notifications.genericError',
        ssoVerificationError: 'notifications.ssoVerificationError',
        connectionProblemError: 'notifications.couldNotConnectToServer',
        incorrectCredentials: 'notifications.incorrectCredentials',
        emailAlreadyExists: 'notifications.emailAlreadyExists',
        dependentOncePerHourError: 'notifications.dependentOncePerHourError',
        userInfoEmailUpdated: 'notifications.userInfoEmailUpdated',
        emailConfirmed: 'notifications.emailConfirmed',
        userInfoUpdateSuccess: 'notifications.userInfoUpdateSuccess',
        currentPasswordIncorrect: 'notifications.currentPasswordIncorrect',
        passwordChangedSuccess: 'notifications.passwordChangedSuccess',
        sessionCanceled: 'notifications.sessionCanceled',
    },
    contentful: {
        spaceId: 'a9kub91sykpy',
        accessToken: 'b6fc9d970cc250e640576cdb0c10fd6746a2337bd65b8338eb297eb44fdc090e',
        contentPreviewToken: '4ee3169800a35b4443c36dcb9c0f8ef8039870dd369b8fb12c52dd9771ea670e',
    },
};
